import React from 'react';
import { connect } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { ImageSection } from 'app/components/ImageSection';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';
import { RootState } from 'app/store/types';
import { DocumentUploadButton } from 'app/components/DocumentUploadButton';
import { DownloadChecklist } from 'app/components/DownloadChecklist';

interface Props extends WithTranslation {
  confirmationImage   : string;
}

const ConfirmationCommercialComponent = (props: Props) => {
  const { confirmationImage, t } = props;

  return (
    <Grid container={false}>
      <Grid item classes={{ item: 'noStepper' }}>
        <ImageSection image={confirmationImage}>
          <Typography variant='h6' classes={{ h6: 'titleMargin section' }}>
            {t('confirmationCommercial.title', { defaultValue: 'Thank you!' })}
          </Typography>
          <Typography variant='body2' paragraph={true}>
            <Trans i18nKey='confirmationCommercial.paragraph1'>
              Please upload the last 3 years of your Business Financial Statements
            </Trans>
          </Typography>
          <Grid container justifyContent='center'>
            <Grid item xs={12}>
              <DownloadChecklist />
            </Grid>
          </Grid>
          <Grid container justifyContent='center'>
            <Grid item xs={12}>
              <DocumentUploadButton />
            </Grid>
          </Grid>
        </ImageSection>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: RootState, ownProps: any) => ({
  confirmationImage : state.config.confirmationImage,
  ...ownProps,
});

export const ConfirmationCommercial = connect(
  mapStateToProps,
  null,
)(withTranslation()(ConfirmationCommercialComponent));
